($ => {
	let utils;
	const LABEL_URL = '/action/addSiteLabel';

	function init() {
		utils = Fw.component.models().utils;
		setupCarousels();
		$('.com-events-admin-event, .com-events-admin-webconf').on('change', handleTypeChange);
		$('.com-events__admin-submit').on('click', saveAdminConfig);
		$('.com-events__admin-form-list').on('click', '.com-events__admin-form-item', removeElementFromList);
	}

	function handleTypeChange({currentTarget}) {
		let $e = $(currentTarget);
		let $ctn = $e.closest('.com-events__admin');
		let $tab = $e.closest('.stool-shared-tab-ctn'); 
		let { name, value } = currentTarget;
		let type = name.indexOf('webconf') > -1 ? 'webconf' : 'event'; 
		
		$tab.find('.com-events__admin-form').hide();
		$tab.find(`.com-events__admin-form[data-id="${value}"]`).show();
	}
	
	function saveAdminConfig({currentTarget}) {
		let $e = $(currentTarget);
		let key = currentTarget.dataset.key;
		let $com = $e.closest('.com-events__admin');
		let valueEvents = '';
		let typeEvents = $('.com-events-admin-event:checked', $com).val();
		let valueWebconf = '';
		let typeWebconf = $('.com-events-admin-webconf:checked', $com).val();
		let data = {
			size: $('.com-events-admin-size:checked', $com).val(),
			showEvents: $('.com-events-admin-show-event', $com).prop('checked').toString(),
			typeEvents,
			showWebconf: $('.com-events-admin-show-webconf', $com).prop('checked').toString(),
			countWebconf: utils.clamp($('.com-events-admin-webconf-count', $com).val(), 1, 10, 5).toString(),
			typeWebconf,
		};

		if ($com.find('.com-events__display-type-btn:checked').val() === 'list') {
			// for pager
			data.perPage = utils.clamp($('.com-events-admin-event-count', $com).val(), 1, 10).toString();
		} else {
			// for items limit, no pager
			data.countEvents = utils.clamp($('.com-events-admin-event-count', $com).val(), 1, 10).toString();
		}

		data.valueEvents = getValueByType($com.find('.stool-shared-tab-ctn[data-tab="com-events-events"]'), typeEvents);
		data.valueWebconf = getValueByType($com.find('.stool-shared-tab-ctn[data-tab="com-events-webconferences"]'), typeWebconf);

		$com.find('.form-message').hide().removeClass('form-message_fade_out');
		$e.addClass('has-processing_active');
		$.ajax({
			url: LABEL_URL,
			type: 'POST',
			data: {
				key,
				value: JSON.stringify(data)
			},
			success: () => {
				let success = $com.find('.form-message_success');
				success.show();
				setTimeout(() => success.addClass('form-message_fade_out'), 1);
			},
			error: () => {
				let error = $com.find('.form-message_server-error');
				error.show().css();
				setTimeout(() => error.addClass('form-message_fade_out'), 1);
			},
			complete: () => {
				$e.removeClass('has-processing_active');
			}
		});
	}

	function getValueByType($tab, type) {
		if (type === 'category') {
			return $tab.find('.com-events__admin-form[data-id="category"] select').val();
		} else if (type === 'custom') {
			return $tab.find('.com-events__admin-form-item').map((i, el) => el.dataset.id).get().join();
		}
	}

	function removeElementFromList(e) {
		e.currentTarget.parentNode.removeChild(e.currentTarget);
	}

	function setupCarousels() {
		const carousels = $('.com-events__carousel');

		carousels.each((_, carousel) => {
			const context = $(carousel).closest('.com-events__container');
			const prevArrow = $('.com-events__nav-arrow_prev', context);
			const nextArrow = $('.com-events__nav-arrow_next', context);
			const isBig = $(carousel).hasClass('com-events__carousel_big');
			$(carousel).slick({
				infinite: false,
				slidesToShow: isBig ? 1 : 2,
				slidesToScroll: 1,
				dots: false,
				prevArrow,
				nextArrow,
				accessibility: true,
				variableWidth: false,
				responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: isBig ? 1 : 3.2,
						}
					},
					{
						breakpoint: 1280,
						settings: {
							slidesToShow: isBig ? 1 : 2.2,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: isBig ? 1 : 2.1,
						}
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		});
	}

	$(init);
})(jQuery);